function findPointForm(onFound, maxAttempts = 10, interval = 500) {
  let attemptCount = 0;
  
  const searchFunction = function() {
    const pointForm = document.querySelector('.shopify-section vip-app-point-use-form');
    if (pointForm) {
      const parentSection = pointForm.closest('.shopify-section');
      if (parentSection && onFound) {
        onFound(parentSection);
      }
      return true;
    }
    
    // 最大試行回数に達した場合は終了
    attemptCount++;
    if (attemptCount >= maxAttempts) {
      console.log('ポイントブロックが見つかりませんでした');
      return true;
    }
    
    return false;
  };
  
  // 定期的に探す
  const intervalId = setInterval(function() {
    if (searchFunction()) {
      clearInterval(intervalId);
    }
  }, interval);
  
  return intervalId;
}

/**
 * ポイント利用フォームを非表示にする処理
 */
function hidePointForm() {
  findPointForm(function(parentSection) {
    parentSection.style.display = 'none';
  });
}

/**
 * ポイント利用表示の重複を防ぐ処理
 */
function hidePointSubtotal() {
  const discountPointSubtotal = document.querySelector('.cart--order-discount-wrapper .cart__subtotal-title');
  console.log(discountPointSubtotal);
  if (discountPointSubtotal && discountPointSubtotal.textContent.includes('ポイント利用')) {
    discountPointSubtotal.closest('p').style.display = 'none';
  }
}

/**
 * ポイント利用フォームを移動する処理
 */
function movePointForm(targetElement) {
  findPointForm(function(parentSection) {
    targetElement.appendChild(parentSection);
    const pointFormTitle = parentSection.querySelector('h3');
    
    // ポイント利用タイトルの文言変更
    pointFormTitle.textContent = 'ポイント利用:';

    // 保有ポイントの文言を変更
    setTimeout(function() {
      const totalPoint = parentSection.querySelector('.vip-app-point-use-form-block p');
      const pointInput = parentSection.querySelector('.vip-app-point-use-form-block input');

      if (totalPoint) {
        const pointText = totalPoint.textContent;
        const pointValueParts = pointText.split('ポイント');
        if (pointValueParts.length > 0) {
          totalPoint.textContent = pointValueParts[0].trim() + 'pt（円相当）利用可能';
        }

        if (pointInput) {
          pointInput.setAttribute('placeholder', '0');
        }
      }

      // テキスト変更を検知するためのMutationObserverを設定
      setupPointFormObserver(parentSection);
    }, 500);
    
  });
}

/**
 * ポイント利用フォームのテキス/ボタンテキストの変更（適用後）
 */
function setupPointFormObserver(parentSection) {
  const pointButton = parentSection.querySelector('.vip-app-point-use-form-block button');

  if (pointButton) {
    const buttonTextObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          const buttonText = pointButton.textContent;
          const pointStatusText = parentSection.querySelector('.vip-app-point-use-form-block > div > div > p');

          // 「解除」という文字が含まれていたら背景色を変更
          if (buttonText && buttonText.includes('解除')) {
            pointButton.style.backgroundColor = '#fff';
            pointButton.style.color = '#5E6245';
            pointButton.style.border = '1px solid #5E6245';

            // ポイント適用文言変更
            if (pointStatusText && pointStatusText.textContent.includes('ポイント')) {
              const pointValue = pointStatusText.textContent.split('ポイント')[0].trim();
              pointStatusText.textContent = pointValue + 'pt適用済み/チェックアウト時に反映されます';
            }

            // 割引ポイントの重複表示を非表示に
            hidePointSubtotal();
          } else {
            pointButton.style.backgroundColor = '';
            pointButton.style.color = '';
            pointButton.style.border = '';
          }
        }
      });
    });
    buttonTextObserver.observe(pointButton, { 
      characterData: true, 
      childList: true, 
      subtree: true 
    });
  }
}

/**
 * デバイスサイズに応じたカートアトリビュート配置を管理する関数
 */
function handleResponsiveCartElements() {
  const pcContainer = document.querySelector('.custom-cart__bottom-item._pc-only');
  const spContainer = document.querySelector('.custom-cart__bottom-item._sp-only');
  const contentElements = {
    note: null,
    services: null
  };

  // コンテナが存在しない場合は処理しない
  if (!pcContainer || !spContainer) return;

  // 最初にpcコンテナから内容を取得
  if (pcContainer.querySelector('.custom-cart__note')) {
    contentElements.note = pcContainer.querySelector('.custom-cart__note');
  }
  if (pcContainer.querySelector('.custom-cart__add-service')) {
    contentElements.services = pcContainer.querySelector('.custom-cart__add-service');
  }

  // 画面サイズに応じて要素を適切なコンテナに移動する関数
  function moveElementsBasedOnScreenSize() {
    const isMobile = window.innerWidth < 768;
    
    // 両方のコンテナを空にする
    pcContainer.innerHTML = '';
    spContainer.innerHTML = '';
    
    // 現在のサイズに応じて要素を配置
    const targetContainer = isMobile ? spContainer : pcContainer;
    
    // 要素を追加
    if (contentElements.note) {
      targetContainer.appendChild(contentElements.note);
    }
    if (contentElements.services) {
      targetContainer.appendChild(contentElements.services);
    }
  }

  // 初期実行
  moveElementsBasedOnScreenSize();
  
  // リサイズイベントのリスナー追加
  window.addEventListener('resize', moveElementsBasedOnScreenSize);
};

document.addEventListener('DOMContentLoaded', function() {
  const cartPointForm = document.querySelector('.js-cartPointForm');
  
  if (!cartPointForm) {
    // .js-cartPointFormが見つからない場合は、ポイントフォームを非表示にする
    hidePointForm();
  } else {
    // .js-cartPointFormが見つかった場合は、ポイントフォームを移動する
    movePointForm(cartPointForm);
  }

  // 割引ポイントの重複表示を非表示に
  hidePointSubtotal();
  
  // レスポンシブ対応のカート要素ハンドラを実行
  handleResponsiveCartElements();
});
